import { useDeepCompareMemo } from 'use-deep-compare';
import { Point, PointColorConfiguration } from '../../types';
import { calculateSafeMax } from './utils/calculateSafeMax';

export function useAdaptivePointColorConfig<P extends Point = Point>(
  points: P[],
  baseConfig: PointColorConfiguration<P>
): PointColorConfiguration<P> {
  return useDeepCompareMemo(() => {
    return {
      ...baseConfig,
      max: calculateSafeMax<P>(
        points,
        (p) => p[baseConfig.property],
        baseConfig.min,
        baseConfig.max
      ),
    };
  }, [points, baseConfig]);
}
